var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconProfessionalNetworkLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 14,
  x: 2,
  y: 8.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.48 6.5A2.5 2.5 0 1 0 2 4a2.49 2.49 0 0 0 2.48 2.5M18.5 22.5h3a.5.5 0 0 0 .5-.5v-8.4C22 9.83 19.87 8 16.89 8a4.22 4.22 0 0 0-3.18 1.28.39.39 0 0 1-.45.09A.4.4 0 0 1 13 9a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 9 9v13a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-7.5a2.5 2.5 0 0 1 5 0V22a.5.5 0 0 0 .5.5"
}))));
export default SvgStreamlineIconProfessionalNetworkLinkedin;